import { useContext } from 'react';
import { useContainer, isClient } from '@okee-uikit/react-hooks';
import { LayerContext } from '../context/layer';
export function useLayer() {
  var toBody = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var layer = useContext(LayerContext);
  var result = useContainer(layer);

  if (!layer || toBody) {
    return function () {
      return isClient() ? document.body : null;
    };
  }

  return result;
}